import React from 'react';
import './App.css';
import RouteIndex from './routers/routes/index';

const App = (): React.ReactElement => (
  <div className="App">
    <RouteIndex />
  </div>
);

export default App;
